import template from './password-request.html';
import controller from './password-request.controller';
import './password-request.scss';

let PasswordRequestComponent = {
  bindings: {},
  template,
  controller
};

export default PasswordRequestComponent;



// WEBPACK FOOTER //
// ./src/app/pages/password-request/password-request.component.js